import { darken, invert, lighten, transparentize } from 'polished'
import { getContrast } from 'src/utils/getContrast'
import logo from 'src/visual/image/kenai-logo-light.svg'
import logoSmall from 'src/visual/image/icon-kenai-bot-light.svg'
import { palette } from '..'
import config from 'src/config'

const textColor = '#e3e3e3'
const disabledColor = darken(0.6, textColor)
const componentBackground = '#1d1c1e'
const borderColor = 'rgba(51, 50, 50, 1)'

const darkTheme = (primaryColor = config.primaryColor) => ({
  primaryColor,
  primaryHover: lighten(0.1, primaryColor),
  primaryColorA04: transparentize(0.4, primaryColor),
  primaryColorA07: transparentize(0.7, primaryColor),
  primaryContrast: lighten(0.1, primaryColor),
  secondaryColor: '#fff',
  secondaryHover: '#000',
  bodyBackground: '#242325',
  tabsGray: '#ACB6BF',
  componentBackground,
  contrastBackground: '#161518',
  textColor,
  textColorSecondary: darken(0.4, textColor),
  textColorInvert: invert(textColor),
  textColorHover: lighten(0.7, textColor),
  textColorA015: transparentize(0.15, textColor),
  textColorA075: transparentize(0.75, textColor),
  borderColor,
  borderColorA06: transparentize(0.6, borderColor),
  disabledColor,
  disabledColorA04: transparentize(0.4, disabledColor),
  disabledColorA06: transparentize(0.6, disabledColor),
  itemActiveBackground: transparentize(0.8, primaryColor),
  itemHoverBackground: transparentize(0.9, primaryColor),
  itemActiveColor: getContrast(primaryColor, textColor) > 7 ? textColor : invert(textColor),
  logo: `url(${logo})`,
  logoSmall: `url(${logoSmall})`,
  errorColor: palette.error[0],
  error100: palette.error[1],
  errorA08: transparentize(0.8, palette.error[2]),
  errorBackground: transparentize(0.95, palette.error[0]),
  errorBorder: transparentize(0.5, palette.error[0]),
  warningText: palette.warning[0],
  warningBackground: transparentize(0.8, palette.warning[0]),
  warningBorder: transparentize(0.5, palette.warning[0]),
  pickerDropdown: lighten(0.05, componentBackground),
  crispBlack: '#000',
  basicBlack: '#1D1D1D',
})

export default darkTheme
